import { render, staticRenderFns } from "./TextValueHolder.vue?vue&type=template&id=185a80dc&scoped=true&"
import script from "./TextValueHolder.vue?vue&type=script&lang=js&"
export * from "./TextValueHolder.vue?vue&type=script&lang=js&"
import style0 from "./TextValueHolder.vue?vue&type=style&index=0&id=185a80dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185a80dc",
  null
  
)

export default component.exports